"use client";

import React, { type PropsWithChildren, useEffect, useState } from "react";

import UiMessageSanctioned from "@/components/Ui/Message/Sanctioned";

import useIpOfac from "@/hooks/api/useIpOfac";

export default function ContextSanctioned({ children }: PropsWithChildren) {
  const [sanctioned, setSanctioned] = useState<boolean>(false);
  const { data } = useIpOfac();
  useEffect(() => {
    if (data) {
      setSanctioned(data.sanctioned);
    }
  }, [data]);
  return sanctioned ? <UiMessageSanctioned /> : children;
}
